import React from 'react';
import { Star, Users, ThumbsUp, Clock } from 'lucide-react';

/**
 * SocialProof — stats bar + testimonial cards.
 * Props:
 *   stats – { studentsServed, satisfaction, avgCompletion }
 *   testimonials – array of { name, country, university, quote, rating }
 *   theme – theme object
 */
export default function SocialProof({ stats, testimonials, theme }) {
  return (
    <div className="space-y-4">
      {/* Stats bar */}
      <div className="grid grid-cols-3 gap-3">
        <div className="flex flex-col items-center p-3.5 rounded-xl bg-white shadow-sm">
          <Users className="w-4 h-4 mb-1.5" style={{ color: theme.accent }} />
          <span className="text-lg font-bold text-gray-900">{stats.studentsServed}</span>
          <span className="text-[11px] text-gray-500 font-medium">Students Served</span>
        </div>
        <div className="flex flex-col items-center p-3.5 rounded-xl bg-white shadow-sm">
          <ThumbsUp className="w-4 h-4 mb-1.5" style={{ color: theme.accent }} />
          <span className="text-lg font-bold text-gray-900">{stats.satisfaction}</span>
          <span className="text-[11px] text-gray-500 font-medium">Satisfaction</span>
        </div>
        <div className="flex flex-col items-center p-3.5 rounded-xl bg-white shadow-sm">
          <Clock className="w-4 h-4 mb-1.5" style={{ color: theme.accent }} />
          <span className="text-lg font-bold text-gray-900">{stats.avgCompletion}</span>
          <span className="text-[11px] text-gray-500 font-medium">Avg. Completion</span>
        </div>
      </div>

      {/* Testimonials */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {testimonials.map((t, idx) => (
          <div
            key={idx}
            className="p-4 rounded-xl"
            style={{ backgroundColor: theme.lightBg }}
          >
            <div className="flex items-center gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`w-3.5 h-3.5 ${i < t.rating ? 'fill-amber-400 text-amber-400' : 'text-gray-200'}`}
                />
              ))}
            </div>
            <p className="text-sm text-gray-600 italic leading-relaxed mb-3">"{t.quote}"</p>
            <div className="flex items-center gap-2.5">
              {/* Avatar initials */}
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold"
                style={{ backgroundColor: theme.accent }}
              >
                {t.name.split(' ').map(n => n[0]).join('')}
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800">{t.name}</p>
                <p className="text-xs text-gray-500">{t.country} · {t.university}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
